import { useTimelineStore, selectTimeline } from '@/lib/store/timeline-store'
import { colorFromUserId } from '@/lib/utils/avatar'
import { stripReplyFallback } from '@/lib/utils/message'

interface ReplyPreviewProps {
  roomId: string
  replyToEventId: string
  onJumpTo?: (eventId: string) => void
}

export function ReplyPreview({ roomId, replyToEventId, onJumpTo }: ReplyPreviewProps) {
  const timeline = useTimelineStore(selectTimeline(roomId))
  const replyEvent = timeline.find((e) => e.eventId === replyToEventId)

  if (!replyEvent) {
    return (
      <div className="reply-quote">
        <span className="reply-bar" style={{ background: 'rgb(var(--np-tx-muted)/0.4)' }} />
        <span className="reply-text italic">Original message not loaded</span>
      </div>
    )
  }

  const senderName = replyEvent.senderName
  const senderColor = colorFromUserId(replyEvent.sender)
  const body = stripReplyFallback((replyEvent.content.body as string) ?? '')
  const isImage = replyEvent.content.msgtype === 'm.image'

  return (
    <button
      className="reply-quote"
      onClick={(e) => {
        e.stopPropagation()
        onJumpTo?.(replyToEventId)
      }}
    >
      <span className="reply-bar" style={{ background: senderColor }} />
      <span className="reply-content">
        <span className="reply-name" style={{ color: senderColor }}>{senderName}</span>
        <span className="reply-text">{isImage ? '📷 Photo' : body || 'Attachment'}</span>
      </span>
    </button>
  )
}
